export const menu_list = [
  {
    id: 2,
    label: 'Store Operations',
    children: [
      {
        id: 21,
        label: 'Cash Collection',
        children: [
          {
            id: 211,
            label: 'Master',
            children: [
              {
                id: 2111,
                label: 'Collection Centers',
                link: '/collectioncenter',
              },
            ],
          },
          {
            id: 212,
            label: 'Entries',
            link: '/entries',
          },
          // {
          //   id: "213",
          //   label: "Reports",
          //   link: "/reports"
          // }
        ],
      },
      {
        id: 22,
        label: 'Bill Management',
        children: [
          {
            id: 221,
            label: 'Master',
            children: [
              {
                id: 2211,
                label: 'Bill Parameters',
                link: '/bill-parameters',
              },
            ],
          },
          {
            id: 22,
            label: 'Bill Details',
            link: '/bill-details',
          },
          {
            id: 23,
            label: 'Bill Consolidated',
            link: '/bill-report',
          },
        ],
      },
    ],
  },
  {
    id: 3,
    label: 'Fixed Assets',
    children: [
      {
        id: 31,
        label: 'Master',
        children: [
          {
            id: 311,
            label: 'Asset Category',
            link: '/assetcategory ',
          },
        ],
      },
      {
        id: 32,
        label: 'GRN',
        link: '/grn',
      },
      {
        id: 33,
        label: 'Disposals',
        link: '/disposals',
      },
      {
        id: 34,
        label: 'Assets Transfer',
        link: '/assetstransfer',
      },
      {
        id: 35,
        label: 'Reports',
        children: [
          {
            id: 351,
            label: 'Stock Registry',
            link: '/stockreport ',
          },
          {
            id: 352,
            label: 'FA Depreciation',
            link: '/depreciation-report',
          },
          {
            id: 354,
            label: 'FAD',
            link: '/fa-depreciation',
          },
          {
            id: 353,
            label: 'FA Dep Cons',
            link: '/depreciation-consolidated-report',
          },
        ],
      },
    ],
  },
  {
    id: 4,
    label: 'Vehicle Management',
    children: [
      {
        id: 41,
        label: 'Dashboard',
        link: '/vm/dashboard',
      },
      {
        id: 42,
        label: 'Vehicle Requests',
        link: '/vm/vehicle-requests',
      },
      {
        id: 43,
        label: 'Purchase Orders',
        link: '/vm/purchase-orders',
      },
      {
        id: 44,
        label: 'Running Vehicle',
        link: '/vm/running-vehicle',
      },
      {
        id: 46,
        label: 'Log Sheet',
        link: '/vm/log-sheet',
      },

      {
        id: 45,
        label: 'Reports',
        children: [
          {
            id: 451,
            label: 'Vehicle Expense Report',
            link: '/vm/log-sheet-report',
          },
          {
            id: 452,
            label: 'Report',
            link: '/vm/report',
          },
          {
            id: 453,
            label: 'IOCL Report ',
            link: '/vm/iocl-report',
          },
        ],
      },
    ],
  },
  {
    id: 10,
    label: 'Machine Management',
    children: [
      {
        id: 101,
        label: 'Dashboard',
        link: '/mm/dashboard',
      },
      {
        id: 102,
        label: 'Requests',
        link: '/mm/machine-requests',
      },
      {
        id: 103,
        label: 'Purchase Orders',
        link: '/mm/purchase-orders',
      },
      {
        id: 104,
        label: 'Installation',
        link: '/mm/installation',
      },
      {
        id: 105,
        label: 'Reports',
        children: [
          {
            id: 1051,
            label: 'Machine Expense',
            link: '/mm/machine-expense-report',
          },
          {
            id: 1052,
            label: 'Report',
            link: '/mm/report',
          },
        ],
      },
    ],
  },
  {
    id: 8,
    label: 'Inventory Management',
    children: [
      {
        id: 81,
        label: 'Purchase Process',
        children: [
          {
            id: 811,
            label: 'Raw Material Indents',
            link: '/inv/indents',
          },
          {
            id: 812,
            label: 'Purchase Order',
            link: '/inv/purchase-order',
          },
          {
            id: 813,
            label: 'Report',
            link: '/inv/report',
          },
        ],
      },
      {
        id: 82,
        label: 'GRN',
        link: '/inv/grn',
      },
      {
        id: 83,
        label: 'Debit Notes',
        link: '/inv/debit-notes',
      },
      {
        id: 84,
        label: 'Production Indents',
        link: '/inv/production-indent',
      },
      {
        id: 85,
        label: 'Godown Stock',
        children: [
          {
            id: 851,
            label: 'PM Stock Transfer',
            link: '/inv/pm-stock-transfer',
          },
          {
            id: 852,
            label: 'PM Delivery Challan',
            link: '/inv/pm-delivery-challan',
          },
          {
            id: 853,
            label: 'Godown Items',
            link: '/inv/godown-items',
          },
        ],
      },
      {
        id: 86,
        label: 'JW Stock',
        children: [
          {
            id: 861,
            label: 'JW Transfer',
            link: '/inv/jw-transfer',
          },
          {
            id: 862,
            label: 'JW DC',
            link: '/inv/jw-dc',
          },
          {
            id: 864,
            label: 'JW GRN',
            link: '/inv/jw-grn',
          },
          {
            id: 866,
            label: 'JW DAMAGE',
            link: '/inv/jw-damage',
          },
          {
            id: 865,
            label: 'JW Items',
            link: '/inv/jw-items',
          },
        ],
      },
      {
        id: 87,
        label: 'Reports',
        children: [
          {
            id: 871,
            label: 'Current Stock',
            link: '/inv/current-stock',
          },
          {
            id: 872,
            label: 'Finished Goods',
            children: [
              {
                id: 8721,
                label: 'Detailed Report',
                link: '/inv/finished-goods-detailed',
              },
              {
                id: 8722,
                label: 'Summary Report',
                link: '/inv/finished-goods-summary',
              },
            ],
          },
          {
            id: 873,
            label: 'Vendor Price',
            link: '/inv/vendor-price-report',
          },
          {
            id: 874,
            label: 'Monthly Price Change',
            link: '/inv/monthly-vendor-price-change-report',
          },
          {
            id: 875,
            label: 'GRN Con. Report',
            link: '/inv/grn-consolidated-report',
          },
          {
            id: 876,
            label: 'PI Con. Report',
            link: '/inv/pi-consolidated-report',
          },
          {
            id: 877,
            label: 'Rejected Items Report',
            link: '/inv/rejected-item-report',
          },
          {
            id: 878,
            label: 'Stock Details Report',
            link: '/inv/stock-details-report',
          },
          {
            id: 879,
            label: 'Item Utilization Con.',
            link: '/inv/item-utilization-report',
          },
          {
            id: 880,
            label: 'Kitchen Con. Report',
            link: '/inv/kitchen-consolidated-report',
          },
          {
            id: 881,
            label: 'JW Vendor Report',
            children: [
              {
                id: 8801,
                label: 'Invoice Wise',
                link: '/inv/jw-vendor-invoice-report',
              },
              {
                id: 8802,
                label: 'GRN Wise',
                link: '/inv/jw-vendor-grn-report',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 11,
    label: 'Building Agreements',
    children: [
      {
        id: 111,
        label: 'Dashboard',
        link: '/agr/dashboard',
      },
      {
        id: 1121,
        label: 'Agreements',
        link: '/agr/agreement-list',
      },
      {
        id: 113,
        label: 'Report',
        link: '/agr/reports',
      },
    ],
  },
  {
    id: 5,
    label: 'Coupons',
    children: [
      {
        id: 51,
        label: 'Companies',
        link: '/cs/companies',
      },
      {
        id: 52,
        label: 'Coupons',
        link: '/cs/coupons',
      },
      {
        id: 53,
        label: 'Reports',
        link: '/cs/reports',
      },
      {
        id: 54,
        label: 'Redeem Coupon',
        link: '/cs/redeem-coupon',
      },
    ],
  },
  {
    id: 9,
    label: 'Cake Management',
    children: [
      {
        id: 91,
        label: 'Master',
        children: [
          {
            id: 911,
            label: 'Category',
            link: '/cake/categories',
          },
          {
            id: 912,
            label: 'Sub-Category',
            link: '/cake/sub-categories',
          },
          {
            id: 913,
            label: 'Shapes',
            link: '/cake/shapes',
          },
          {
            id: 914,
            label: 'Flavours',
            link: '/cake/flavours',
          },
          {
            id: 915,
            label: 'Namkeen Order Blocks',
            link: '/cake/namkeen-order-blocks',
          }
        ],
      },
      {
        id: 94,
        label: 'Home',
        link: '/cake/home',
      },
      {
        id: 92,
        label: 'Products',
        link: '/cake/products',
      },
      {
        id: 93,
        label: 'Orders',
        children: [
          {
            id: 931,
            label: 'Cake Orders',
            link: '/cake/orders',
          },
          {
            id: 932,
            label: 'Namkeen Orders',
            link: '/cake/namkeen-orders',
          },
          {
            id: 933,
            label: 'Dispatch Report',
            link: '/cake/namkeen-dc-details',
          },
          {
            id: 934,
            label: 'Namkeen Rejected',
            link: '/cake/rejected-namkeen-orders',
          },
        ],
      },
    ],
  },
  {
    id: 6,
    label: 'Festival',
    children: [
      {
        id: 61,
        label: 'Master',
        children: [
          {
            id: 611,
            label: 'Category',
            link: '/fest/category',
          },
          {
            id: 612,
            label: 'Products',
            link: '/fest/products',
          },
          {
            id: 613,
            label: 'Festivals',
            link: '/fest/festivals',
          },
          {
            id: 614,
            label: 'Festival Dates',
            link: '/fest/dates',
          },
        ],
      },
      {
        id: 62,
        label: 'Requirements',
        link: '/fest/requirements',
      },
      {
        id: 63,
        label: 'Report',
        children: [
          {
            id: 631,
            label: 'Festival Datewise',
            link: '/fest/report/date-consolidated',
          },
          {
            id: 632,
            label: 'Festival Wise Consd',
            link: '/fest/report/date-wise',
          },
          {
            id: 633,
            label: 'Festival Datewise Consd',
            link: '/fest/report/datewise-consolidated',
          },
        ],
      },
    ],
  },
  {
    id: 12,
    label: 'Ks Ads',
    children: [
      {
        id: 121,
        label: 'Home',
        link: '/ks-ads/home',
      },
    ],
  },
  {
    id: 7,
    label: 'Settings',
    children: [
      {
        id: 71,
        label: 'Users',
        link: '/users',
      },
      {
        id: 72,
        label: 'Vendors',
        link: '/vendormaster',
      },
      {
        id: 73,
        label: 'Locations',
        link: '/locations',
      },
      {
        id: 74,
        label: 'Companies',
        link: '/companies',
      },
      {
        id: 75,
        label: 'Items',
        link: '/inv/items',
      },
      {
        id: 76,
        label: 'Item Categories',
        link: '/inv/item-categories',
      },
      {
        id: 77,
        label: 'Kitchen',
        link: '/inv/kitchen',
      },
    ],
  },
];

export const faAdminMenu = [
  {
    id: 1,
    label: 'Fixed Assets',
    children: [
      {
        id: 11,
        label: 'Master',
        children: [
          {
            id: 111,
            label: 'Asset Category',
            link: '/assetcategory ',
          },
        ],
      },
      {
        id: 12,
        label: 'GRN',
        link: '/grn',
      },
      {
        id: 1,
        label: 'Disposals',
        link: '/disposals',
      },
      {
        id: 14,
        label: 'Assets Transfer',
        link: '/assetstransfer',
      },
      {
        id: 15,
        label: 'Reports',
        children: [
          {
            id: 151,
            label: 'Stock Registry',
            link: '/stockreport ',
          },
        ],
      },
    ],
  },
];
export const faManagerMenu = JSON.parse(JSON.stringify(faAdminMenu));
faManagerMenu[0].children = faManagerMenu[0].children.filter((menu) => menu.id !== 11);

export const storeOperatorMenu = [
  {
    id: 1,
    label: 'Store Operations',
    children: [
      {
        id: 11,
        label: 'Cash Collection',
        children: [
          {
            id: 111,
            label: 'Master',
            children: [
              {
                id: 1111,
                label: 'Collection Centers',
                link: '/collectioncenter',
              },
            ],
          },
          {
            id: 112,
            label: 'Entries',
            link: '/entries',
          },
        ],
      },
      {
        id: 12,
        label: 'Bill Management',
        children: [
          {
            id: 121,
            label: 'Master',
            children: [
              {
                id: 1211,
                label: 'Bill Parameters',
                link: '/bill-parameters',
              },
            ],
          },
          {
            id: 122,
            label: 'Bill Details',
            link: '/bill-details',
          },
        ],
      },
    ],
  },
];

export const vehicleManagerMenu = [
  {
    id: '1',
    label: 'Vehicle Management',
    children: [
      {
        id: '11',
        label: 'Dashboard',
        link: '/vm/dashboard',
      },
      {
        id: '12',
        label: 'Vehicle Requests',
        link: '/vm/vehicle-requests',
      },
      {
        id: '13',
        label: 'Purchase Orders',
        link: '/vm/purchase-orders',
      },
      {
        id: '14',
        label: 'Running Vehicle',
        link: '/vm/running-vehicle',
      },
      {
        id: 46,
        label: 'Log Sheet',
        link: '/vm/log-sheet',
      },
      {
        id: 47,
        label: 'Vehicle Expense Report',
        link: '/vm/log-sheet-report',
      },
      {
        id: '15',
        label: 'Report',
        link: '/vm/report',
      },
    ],
  },
];

export const machineManagerMenu = [
  {
    id: '1',
    label: 'Machine Management',
    children: [
      {
        id: 11,
        label: 'Dashboard',
        link: '/mm/dashboard',
      },
      {
        id: 12,
        label: 'Requests',
        link: '/mm/machine-requests',
      },
      {
        id: 13,
        label: 'Purchase Orders',
        link: '/mm/purchase-orders',
      },
      {
        id: 14,
        label: 'Installation',
        link: '/mm/installation',
      },
      {
        id: 15,
        label: 'Report',
        children: [
          {
            id: 151,
            label: 'Machine Expense',
            link: '/mm/machine-expense-report',
          },
          {
            id: 152,
            label: 'Report',
            link: '/mm/report',
          },
        ],
      },
    ],
  },
];

export const festivalManagerMenu = [
  {
    id: '6',
    label: 'Festival',
    children: [
      {
        id: '63',
        label: 'Requirements',
        link: '/fest/requirements',
      },
    ],
  },
];

export const festivalAdminMenu = [
  {
    id: 6,
    label: 'Festival',
    children: [
      {
        id: 61,
        label: 'Master',
        children: [
          {
            id: 611,
            label: 'Category',
            link: '/fest/category',
          },
          {
            id: 612,
            label: 'Products',
            link: '/fest/products',
          },
          {
            id: 613,
            label: 'Festivals',
            link: '/fest/festivals',
          },
          {
            id: 614,
            label: 'Festival Dates',
            link: '/fest/dates',
          },
        ],
      },
      {
        id: 62,
        label: 'Requirements',
        link: '/fest/requirements',
      },
      {
        id: 63,
        label: 'Report',
        children: [
          {
            id: 631,
            label: 'Festival Datewise',
            link: '/fest/report/date-consolidated',
          },
          {
            id: 632,
            label: 'Festival Wise Consd',
            link: '/fest/report/date-wise',
          },
          {
            id: 633,
            label: 'Festival Datewise Consd',
            link: '/fest/report/datewise-consolidated',
          },
        ],
      },
    ],
  },
];

export const couponAdminMenu = [
  {
    id: 1,
    label: 'Coupons',
    children: [
      {
        id: 11,
        label: 'Companies',
        link: '/cs/companies',
      },
      {
        id: 12,
        label: 'Coupons',
        link: '/cs/coupons',
      },
      {
        id: 13,
        label: 'Reports',
        link: '/cs/reports',
      },
    ],
  },
];

export const adminMenu = [...menu_list.filter((menu) => menu.id !== 6)];
export const agreementMenu = [...menu_list.filter((menu) => menu.id === 11)];

// const inventoryManagerMenu = menu_list.map((menu) =>menu.id===8);

export const inventoryManagerMenu = [
  {
    id: '8',
    label: 'Inventory Management',
    children: [
      {
        id: '81',
        label: 'Purchase Process',
        children: [
          {
            id: '811',
            label: 'Raw Material Indents',
            link: '/inv/indents',
          },
          {
            id: '812',
            label: 'Purchase Order',
            link: '/inv/purchase-order',
          },
          {
            id: '813',
            label: 'Report',
            link: '/inv/report',
          },
        ],
      },
      {
        id: '82',
        label: 'GRN',
        link: '/inv/grn',
      },
      {
        id: '83',
        label: 'Debit Notes',
        link: '/inv/debit-notes',
      },
      {
        id: '84',
        label: 'Production Indents',
        link: '/inv/production-indent',
      },
      {
        id: '85',
        label: 'Reports',
        children: [
          {
            id: 851,
            label: 'Current Stock',
            link: '/inv/current-stock',
          },
          {
            id: 852,
            label: 'Vendor Price',
            link: '/inv/vendor-price-report',
          },
          {
            id: 853,
            label: 'GRN Con. Report',
            link: '/inv/grn-consolidated-report',
          },
          {
            id: 854,
            label: 'PI Con. Report',
            link: '/inv/pi-consolidated-report',
          },
          {
            id: 855,
            label: 'Rejected Items Report',
            link: '/inv/rejected-item-report',
          },
          {
            id: 856,
            label: 'Kitchen Con. Report',
            link: '/inv/kitchen-consolidated-report',
          },
        ],
      },
    ],
  },
  {
    id: 2,
    label: 'Setting',
    children: [
      {
        id: 21,
        label: 'Vendors',
        link: '/vendormaster',
      },
      {
        id: 22,
        label: 'Items',
        link: '/inv/items',
      },
    ],
  },
];

export const inventoryManagerMenuWithGodownLocation = [
  {
    id: '8',
    label: 'Inventory Management',
    children: [
      {
        id: '81',
        label: 'Purchase Process',
        children: [
          {
            id: '811',
            label: 'Raw Material Indents',
            link: '/inv/indents',
          },
          {
            id: '812',
            label: 'Purchase Order',
            link: '/inv/purchase-order',
          },
          {
            id: '813',
            label: 'Report',
            link: '/inv/report',
          },
        ],
      },
      {
        id: '89',
        label: 'Debit Notes',
        link: '/inv/debit-notes',
      },
      {
        id: '82',
        label: 'GRN',
        link: '/inv/grn',
      },
      {
        id: '83',
        label: 'Production Indents',
        link: '/inv/production-indent',
      },
      {
        id: 85,
        label: 'Godown Stock',
        children: [
          {
            id: 1,
            label: 'PM Stock Transfer',
            link: '/inv/pm-stock-transfer',
          },
          {
            id: 2,
            label: 'PM Delivery Challan',
            link: '/inv/pm-delivery-challan',
          },
          {
            id: 3,
            label: 'Godown Items',
            link: '/inv/godown-items',
          },
        ],
      },
      {
        id: 86,
        label: 'JW Stock',
        children: [
          {
            id: 1,
            label: 'JW Transfer',
            link: '/inv/jw-transfer',
          },
          {
            id: 2,
            label: 'JW DC',
            link: '/inv/jw-dc',
          },
          {
            id: 3,
            label: 'JW Items',
            link: '/inv/jw-items',
          },
        ],
      },
      {
        id: 84,
        label: 'Reports',
        children: [
          {
            id: 841,
            label: 'Current Stock',
            link: '/inv/current-stock',
          },
          {
            id: 849,
            label: 'Vendor Price',
            link: '/inv/vendor-price-report',
          },
          {
            id: 842,
            label: 'GRN Con. Report',
            link: '/inv/grn-consolidated-report',
          },
          {
            id: 843,
            label: 'PI Con. Report',
            link: '/inv/pi-consolidated-report',
          },
          {
            id: 844,
            label: 'Rejected Items Report',
            link: '/inv/rejected-item-report',
          },
          {
            id: 847,
            label: 'Kitchen Con. Report',
            link: '/inv/kitchen-consolidated-report',
          },
          {
            id: 848,
            label: 'JW Vendor Report',
            children: [
              {
                id: 8481,
                label: 'Invoice Wise',
                link: '/inv/jw-vendor-invoice-report',
              },
              {
                id: 8482,
                label: 'GRN Wise',
                link: '/inv/jw-vendor-grn-report',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    label: 'Setting',
    children: [
      {
        id: 21,
        label: 'Vendors',
        link: '/vendormaster',
      },
      {
        id: 22,
        label: 'Items',
        link: '/inv/items',
      },
    ],
  },
];

export const JWCollectorMenu = [
  {
    id: '8',
    label: 'Inventory Management',
    children: [
      {
        id: 86,
        label: 'JW Stock',
        children: [
          {
            id: 4,
            label: 'JW GRN',
            link: '/inv/jw-grn',
          },
        ],
      },
    ],
  },
];

export const inventoryAdminMenu = [
  {
    id: 1,
    label: 'Inventory Management',
    children: [
      {
        id: 81,
        label: 'Purchase Process',
        children: [
          {
            id: 811,
            label: 'Raw Material Indents',
            link: '/inv/indents',
          },
          {
            id: 812,
            label: 'Purchase Order',
            link: '/inv/purchase-order',
          },
          {
            id: 813,
            label: 'Report',
            link: '/inv/report',
          },
        ],
      },
      {
        id: 82,
        label: 'GRN',
        link: '/inv/grn',
      },
      {
        id: 83,
        label: 'Debit Notes',
        link: '/inv/debit-notes',
      },
      {
        id: 84,
        label: 'Production Indents',
        link: '/inv/production-indent',
      },
      {
        id: 85,
        label: 'Godown Stock',
        children: [
          {
            id: 1,
            label: 'PM Stock Transfer',
            link: '/inv/pm-stock-transfer',
          },
          {
            id: 2,
            label: 'PM Delivery Challan',
            link: '/inv/pm-delivery-challan',
          },
          {
            id: 3,
            label: 'Godown Items',
            link: '/inv/godown-items',
          },
        ],
      },
      {
        id: 86,
        label: 'JW Stock',
        children: [
          {
            id: 1,
            label: 'JW Transfer',
            link: '/inv/jw-transfer',
          },
          {
            id: 2,
            label: 'JW DC',
            link: '/inv/jw-dc',
          },
          {
            id: 4,
            label: 'JW GRN',
            link: '/inv/jw-grn',
          },
          {
            id: 6,
            label: 'JW DAMAGE',
            link: '/inv/jw-damage',
          },
          {
            id: 3,
            label: 'JW Items',
            link: '/inv/jw-items',
          },
        ],
      },
      {
        id: 86,
        label: 'Reports',
        children: [
          {
            id: 861,
            label: 'Current Stock',
            link: '/inv/current-stock',
          },
          {
            id: 862,
            label: 'Vendor Price',
            link: '/inv/vendor-price-report',
          },
          {
            id: 863,
            label: 'GRN Con. Report',
            link: '/inv/grn-consolidated-report',
          },
          {
            id: 864,
            label: 'PI Con. Report',
            link: '/inv/pi-consolidated-report',
          },
          {
            id: 865,
            label: 'Rejected Items Report',
            link: '/inv/rejected-item-report',
          },
          {
            id: 866,
            label: 'Stock Details Report',
            link: '/inv/stock-details-report',
          },
          {
            id: 867,
            label: 'Item Utilization Con.',
            link: '/inv/item-utilization-report',
          },
          {
            id: 868,
            label: 'Kitchen Con. Report',
            link: '/inv/kitchen-consolidated-report',
          },
          {
            id: 869,
            label: 'JW Vendor Report',
            children: [
              {
                id: 8691,
                label: 'Invoice Wise',
                link: '/inv/jw-vendor-invoice-report',
              },
              {
                id: 8692,
                label: 'GRN Wise',
                link: '/inv/jw-vendor-grn-report',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    label: 'Setting',
    children: [
      {
        id: 21,
        label: 'Vendors',
        link: '/vendormaster',
      },
      {
        id: 22,
        label: 'Items',
        link: '/inv/items',
      },
    ],
  },
];

export const cakeManagerMenu = [
  {
    id: 9,
    label: 'Cake Management',
    children: [
      {
        id: 92,
        label: 'Home',
        link: '/cake/home',
      },
      {
        id: 93,
        label: 'Orders',
        children: [
          {
            id: 931,
            label: 'Cake Orders',
            link: '/cake/orders',
          },
          {
            id: 932,
            label: 'Namkeen Orders',
            link: '/cake/namkeen-orders',
          },
          {
            id: 933,
            label: 'Dispatch Report',
            link: '/cake/namkeen-dc-details',
          },
          {
            id: 934,
            label: 'Namkeen Rejected',
            link: '/cake/rejected-namkeen-orders',
          },
        ],
      },
    ],
  },
];

export const adsManagerMenu = [
  {
    id: 12,
    label: 'Ks Ads',
    children: [
      {
        id: 121,
        label: 'Home',
        link: '/ks-ads/home',
      },
    ],
  },
];

export const superAdminMenu = [...menu_list];

export const storeManagerMenu = [
  {
    id: 1,
    label: 'Store Management',
    children: [],
  },
];

export const couponManagerMenu = [
  {
    id: 1,
    label: 'Coupons',
    children: [
      {
        id: 11,
        label: 'Redeem Coupon',
        link: '/cs/redeem-coupon',
      },
    ],
  },
];
